import request from './request'

export function selectEnabledWareHouse() {
  return request.get('/mes/warehouses/select')
}
export function listWareHouse(data) {
  return request.post('/mes/warehouses/list', data)
}
export function getWareHouse(id) {
  return request.get('/mes/warehouses/' + id)
}
export function saveWareHouse(data) {
  return request.post('/mes/warehouses', data)
}
export function updateWareHouse(data) {
  return request.post('/mes/warehouses/update', data)
}
export function deleteWareHouse(ids) {
  return request.post('/mes/warehouses/delete', ids)
}
export function listWareArea(data) {
  return request.post('/mes/ware-areas/list', data)
}
export function saveWareArea(data) {
  return request.post('/mes/ware-areas', data)
}
export function updateWareArea(data) {
  return request.post('/mes/ware-areas/update', data)
}
export function deleteWareArea(ids) {
  return request.post('/mes/ware-areas/delete', ids)
}
